import React from 'react'
import { createRoot } from 'react-dom/client'
import * as Sentry from '@sentry/react'

import Routes from '../components/Routes'

if (process.env.SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.SENTRY_DSN,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.1,
    environment: process.env.NODE_ENV || 'development'
  })
}

document.addEventListener('DOMContentLoaded', () => {
  const container = document.body.appendChild(document.createElement('div'))
  const root = createRoot(container)
  root.render(<Routes />)
})
